import { busyWhile } from "lib/@components/busy/busy-while"
import { confirmByUserInput } from "lib/@dialogs/confirm-by-user-input"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { deleteAssetRegister } from "routes/asset-register/controller/delete-asset-register"
import { getAssetCount } from "routes/asset-register/controller/get-asset-count"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function RemoveRegisterMenuItem() {
    const { register } = useBoundContext()

    return (
        <ContextMenuItem
            icon="material-symbols:delete"
            label="Remove"
            onClick={remove}
            data-cy="register-row-menu-remove"
        />
    )

    async function remove() {
        try {
            const assetCount = await getAssetCount(register.id)
            if (
                await confirmByUserInput({
                    title: `Are you sure you want to remove ${assetCount} ${"asset".pluralize(assetCount)}?`,
                    confirmValue: assetCount ?? 0,
                })
            ) {
                const result = await busyWhile(async () => deleteAssetRegister(register.id), "Deleting register")
                if (!result) {
                    errorSnackbar("Failed to remove asset register")
                    return
                }
                successSnackbar("Asset register successfully removed")
            }
        } catch (e) {
            errorSnackbar("Failed to remove asset register")
        }
    }
}
